import { useMutation, useQuery, useQueryClient } from 'react-query';
import { StatementSettingsApi } from '../api-client';

const statementApi = new StatementSettingsApi();

export function useStatementSettings() {
  return useQuery({
    queryKey: ['statementSettings'],
    queryFn: () => {
      return statementApi
        .statementSettingsControllerFindSettings()
        .then((response) => {
          return response.data;
        });
    },
  });
}

export function useUpdateStatementSettings() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (props: {
      data: Parameters<
        typeof statementApi.statementSettingsControllerUpdateStatementSettings
      >;
    }) => {
      return statementApi.statementSettingsControllerUpdateStatementSettings(
        ...props.data
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['statementSettings']);
    },
  });
}
